
export default () => {
    const changeConstrastButtons = document.querySelectorAll('#wcag-contrast-change'),
      fontSizeIncreaseButtons = document.querySelectorAll('#wcag-font-increase'),
      fontSizeDecreaseButtons = document.querySelectorAll('#wcag-font-decrease');

    const switchA11y = function() {
    let htmlClasses = document.querySelector('html').classList;
    if (document.querySelector('html').classList.contains('dark')) {
        htmlClasses.remove('dark');
        localStorage.removeItem('themeDark')
    } else {
        htmlClasses.add('dark');
        localStorage.setItem('themeDark', true);
    }
    }

    const fontSizeIncrease = function () {
        let htmlClasses = document.querySelector('html').classList;
        htmlClasses.add('font-increase');
        localStorage.setItem('fontIncrease', true);
    }

    const fontSizeDescrease = function () {
        let htmlClasses = document.querySelector('html').classList;
        htmlClasses.remove('font-increase');
        localStorage.removeItem('fontIncrease')
    }

    if(localStorage.getItem('themeDark')) {
        switchA11y();
    }

    if(localStorage.getItem('fontIncrease')) {
        let htmlClasses = document.querySelector('html').classList;
        htmlClasses.add('font-increase');
    }

    changeConstrastButtons.forEach(btn => {
        btn.addEventListener('click', switchA11y);
    })

    fontSizeIncreaseButtons.forEach(btn => {
        btn.addEventListener('click', fontSizeIncrease);
    })

    fontSizeDecreaseButtons.forEach(btn => {
        btn.addEventListener('click', fontSizeDescrease);
    })
}